import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
// eslint-disable-next-line import/no-cycle
import { trackDialogViewed } from '../../Services/Analytics/TrackEventsService';
import {
  canBookDemo,
  fetchCanBookDemo,
} from '../../Setup/ProgressiveOnboarding/Data';
import { useDataFetcherV2 } from '../Data/useDataFetcher';
import CalendlyPopup from '../../CalendlyPopup';
import { updateCanBookDemo } from '../../Setup/ProgressiveOnboarding/Actions';

const useStyles = makeStyles({
  hide: {
    display: 'none',
  },
});

const BookDemoButton = (location='') => {
  const { hide } = useStyles();
  const dispatch = useDispatch();
  const [demoStatusFetched] = useDataFetcherV2(fetchCanBookDemo);
  const showBookDemo = useSelector(canBookDemo);

  const onOpen = () => {
    dispatch(trackDialogViewed('open', 'calendly_demo'));
  };

  const onDemoBooked = () => {
    dispatch(updateCanBookDemo);
    dispatch(trackDialogViewed('close', 'calendly_demo'));
  };

  if (!demoStatusFetched) return null;

  return (
    <div className={showBookDemo ? null : hide}>
      <CalendlyPopup
        variant="outlined"
        buttonText="BOOK A DEMO"
        onDemoBooked={onDemoBooked}
        onOpen={onOpen}
        location={location}
      />
    </div>
  );
};

export default BookDemoButton;
